import axios from "axios";

const endPoint = process.env.REACT_APP_API_ENDPOINT;

const submitRating = (payload) => {
    const token = process.env.REACT_APP_JWT_BEARER;
    const config = {
        method: "post",
        url: `${endPoint}/add`,
        data: payload,
        headers: {
            "content-type": "application/json",
            "Authorization": token
        },
        crossdomain: true,
        withCredentials: false
    }
    return axios(config)
    .then(response => response.data)
    .catch(error => {
        console.error('Error submitting rating:', error);
        throw error; 
    });
}

const ratingService = {
    submitRating: submitRating
}

export default ratingService;